import ModalContainer from "../../../containers/Modal/ModalContainer";
import { useTranslation } from "react-i18next";
import "../../styles/forms.scss";
import { useGeneralContext } from "../../General/Context";
import { useEffect, useState } from "react";
import { UserService } from "../../../services/UserService";
import { toast } from "react-toastify";
import { InterviewService } from "../../../services/InterviewService";

export default function RecommendedForm({
  isOpen,
  closeForm,
  managers,
  modalTitle,
  submitText,
  commentIsDisabled,
  comment,
  showCheckAllButton,
  checkedRecommended,
  onChangeManagers,
  onChangeUserHR,
  onClickCheckAll,
  onChangeComments,
  submitButton,
  checkBoxIsDisabled,
  hrUsers,
  onClickCheckAllHR,
  checkedRecommendedHR_Users,
  checkedRecommendedOtherManager_Users,
  onChangeOtherManager,
  otherManager,
  onClickCheckAllOtherManager,
  companyAbriviature
}) {
  const { t } = useTranslation();
  const { userInformation } = useGeneralContext();

  return (
    <ModalContainer
      modalTitle={modalTitle}
      submitButtonTitle={submitText}
      submitButtonAction={submitButton}
      closeModal={closeForm}
      isOpen={isOpen}
      cancelButtonTitle={t("Cancel")}
      cancelButtonAction={closeForm}
    >
      {showCheckAllButton && (
        <button
          className="app-button btn-second btn-sm"
          onClick={onClickCheckAll}
        >
          {t("Check All Managers")} {companyAbriviature}
        </button>
      )}

      <div className="recommend-manager-list">
        {managers &&
          managers.map((item) => (
            <div className="form-check form-check-inline" key={item.id}>
              <input
                className="form-check-input"
                type="checkbox"
                id={item.id}
                name={"manager"}
                value={item.id}
                onChange={onChangeManagers}
                checked={checkedRecommended(item.id)}
                disabled={checkBoxIsDisabled(item.id)}
              />
              <label className="form-check-label" htmlFor={"manager"}>
                {t(item.nickname)}
              </label>
            </div>
          ))}
      </div>

      {showCheckAllButton && (
        <button
          className="app-button btn-second btn-sm"
          onClick={onClickCheckAllOtherManager}
        >
          {t("Check All Other Managers")}
        </button>
      )}

      <div className="recommend-manager-list">
        {otherManager &&
          otherManager.map((item) => (
            <div className="form-check form-check-inline" key={item.id}>
              <input
                className="form-check-input"
                type="checkbox"
                id={item.id}
                name={"otherManager"}
                value={item.id}
                onChange={onChangeOtherManager}
                checked={checkedRecommendedOtherManager_Users(item.id)}
                disabled={checkBoxIsDisabled(item.id)}
              />
              <label className="form-check-label" htmlFor={"otherManager"}>
                {t(item.nickname)}
              </label>
            </div>
          ))}
      </div>

      {showCheckAllButton && (
        <button
          className="app-button btn-second btn-sm"
          onClick={onClickCheckAllHR}
        >
          {t("Check All HR")}
        </button>
      )}

      <div className="recommend-manager-list">
        {hrUsers &&
          hrUsers.map((item) => (
            <div className="form-check form-check-inline" key={item.id}>
              <input
                className="form-check-input"
                type="checkbox"
                id={item.id}
                name={"manager"}
                value={item.id}
                onChange={onChangeUserHR}
                checked={checkedRecommendedHR_Users(item.id)}
                disabled={checkBoxIsDisabled(item.id)}
              />
              <label className="form-check-label" htmlFor={"manager"}>
                {t(item.nickname)}
              </label>
            </div>
          ))}
      </div>

      <div className="form-group">
        <div className="label-wrapper">
          <label className="form-label">{t("Comments")}</label>
        </div>
        <textarea
          onChange={onChangeComments}
          value={comment || ""}
          name="comment"
          maxLength="500"
          disabled={commentIsDisabled}
        ></textarea>
      </div>
    </ModalContainer>
  );
}
